/**
 * Form controller
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

class Form {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Assign form element to a variable
        this.forms = $( '.libre-form' );

        // Assign form text input element to a variable
        this.textFields = this.forms.find( '.formcontainer__form-group__form-input--text' );

        // Assign form machine text input element to a variable
        this.machineInput = this.forms.find( '#machine' );

        // Assign select element to a variable
        this.selectFields = this.forms.find( '.formcontainer__form-group__form-input--select' );

        // Assign submit button to a variable
        this.submitButton = this.forms.find( 'input[type="submit"]' );
    }

    events() {

    }

    formInputFocus() {

        // When user clicks the input field, slide the label up
        this.textFields.focus( function() {
            $( this ).parents( '.formcontainer__form-group' ).addClass( 'focused' );
        });

        // If users clicks away from the field and the field is empty, bring the placeholder back
        this.textFields.blur( function() {
            const inputValue = $( this ).val();
            if ( ! inputValue ) {
                $( this ).parents( '.formcontainer__form-group' ).removeClass( 'focused' );
            }
        });
    }

    formValidation() {

        // Check that form or forms exists
        if ( this.forms.length > 0 ) {

            // The keys (e.g. valueMissing) map onto a key in the `input.validity` object
            // These messages are set in lib/Setup.php and then localized
            const customMessages = {
                valueMissing: themeData.themeStrings.form.valueMissing,
                emailMismatch: themeData.themeStrings.form.emailMismatch
            };

            const replaceValidationUI = ( form ) => {

                function getCustomMessage( type, validity ) {

                    // Returns boolean based on the validity of the object
                    if ( validity.typeMismatch ) {

                        // In case of a specific invalid field (e.g email-field), insert error message of that field type
                        return customMessages[`${type}Mismatch`];
                    } else {

                        // Loop through invalid keys and insert the value as an default error message
                        for ( const invalidKey in customMessages ) {
                            if ( validity[invalidKey]) {
                                return customMessages[invalidKey];
                            }
                        }
                    }
                }

                // Suppress the default error message bubbles
                form.addEventListener( 'invalid', function( event ) {
                    event.preventDefault();
                }, true );

                // Support Safari, iOS Safari, and the Android browser—each of which do not prevent
                // form submissions by default
                form.addEventListener( 'submit', function( event ) {
                    if ( ! this.checkValidity() ) {
                        event.preventDefault();
                    }
                });

                // If there are invalid fields create custom error message containers when user tries to submit a form
                this.submitButton[0].addEventListener( 'click', function( event ) {

                    var invalidFields = form.querySelectorAll( ':invalid' ),
                        errorMessages = form.querySelectorAll( '.error-message' ),
                        invalidElement = form.querySelectorAll( '.formcontainer__form-group--invalid' ),
                    parent;

                    // Assign all input field elements to a variable
                    const allFields = document.querySelectorAll( '.formcontainer__form-group__form-input' );

                    // Loop through all input fields and apply custom error messages
                    for ( let i = 0; i < allFields.length; i++ ) {
                        const message = allFields[i].validity.valid ?
                            null : getCustomMessage( allFields[i].type, allFields[i].validity, customMessages );
                        allFields[i].setCustomValidity( message || '' );
                    }

                    // Remove any existing messages
                    for ( let i = 0; i < errorMessages.length; i++ ) {
                        errorMessages[i].parentNode.removeChild( errorMessages[i]);
                        invalidElement[i].classList.remove( 'formcontainer__form-group--invalid' );
                    }

                    for ( let i = 0; i < invalidFields.length; i++ ) {
                        parent = invalidFields[i].parentNode;
                        parent.classList.add( 'formcontainer__form-group--invalid' );
                        parent.insertAdjacentHTML( 'beforeend', '<div class="error-message">' +
                            invalidFields[i].validationMessage +
                            '</div>' );
                    }

                    // If there are errors, give focus to the first invalid field
                    if ( invalidFields.length > 0 ) {
                        invalidFields[0].focus();
                    }
                });
            };

            // Replace the validation UI for all forms
            const forms = document.querySelectorAll( '.libre-form' );
            for ( let i = 0; i < forms.length; i++ ) {
                replaceValidationUI( forms[ i ]);
            }

            // Initiate DustPress JS
            dp( 'Flexible/Flex', {
                success: ( data ) => {

                    const flexibleFields = data.Flexible.Flex;

                    // Get permalink of the form redirect page and pass it to redirect-function
                    for ( const key in flexibleFields ) {
                        if ( flexibleFields[key].acf_fc_layout == 'form_layout' ) {

                            // If submitting a form with a machine field,
                            // remove the selected machine from session storage.
                            if ( this.machineInput.length ) {

                                sessionStorage.removeItem( 'rotator_selected_machine' );
                            }

                            // Redirect
                            const redirectUrl = ( flexibleFields[key].layout.boxes[0].redirectPage );
                            redirect( redirectUrl );
                        }
                    }

                },
                error: function( error ) {
                    console.log( error );
                }
            });

            // Redirect to chosen page after form is validated
            function redirect( url ) {
                if ( url ) {
                    window.wplf.successCallbacks.push(
                        res => window.location.href = url
                    );
                }
            }
        }
    }

    formDropdowns() {

        // Loop through all elements
        this.selectFields.each( function() {
            const $this = $( this );
            const numberOfOptions = $this.children( 'option' ).length;
            const numberOfOptgroups = $this.children( 'optgroup' ).length;

            // Hide the original select element
            $this.addClass( 'select-hidden' );

            // Wrap the elements
            $this.wrap( '<div class="formcontainer__form-group--select--list"></div>' );

            // Add element after the wrap
            $this.after( '<div class="formcontainer__form-group--select--styled"></div>' );

            // Assign element to a variable
            const $styledSelect = $this.next( '.formcontainer__form-group--select--styled' );

            // Assign the first option as the label of the dropdown element
            $styledSelect.text( $this.children( 'option' ).eq( 0 ).text() );

            // Insert list after previous element
            const $list = $( '<ul> ', {
                'class': 'formcontainer__form-group--select--options'
            }).insertAfter( $styledSelect );

            // Insert list after previous element
            const $innerList = $( '<li> ', {
            }).appendTo( $list );

            // Loop through the text and values and insert them into the list
            // Outer loop assigns optgroup values accordingly to the nth item with eq-function
            for ( let i = 0; i < numberOfOptgroups; i++ ) {
                const $moreInnerList = $( '<ul>', {
                    'class': 'formcontainer__form-group--select--options--inner',
                    text: $this.children( 'optgroup' ).eq( i ).attr( 'label' )
                }).appendTo( $innerList );

                // Find the corresponding element in where to insert values from the original select fields with eq-function
                const $childOptions = $this.children( 'optgroup' ).eq( i ).find( 'option' );

                // Count optgroup options (child elements)
                const numberOfOptgroupOptions = $childOptions.length;

                // Inner loop assigns optgroups option values accordingly to the nth item with eq-function
                for ( let j = 0; j < numberOfOptgroupOptions; j++ ) {
                    $( '<li>', {
                        text: $childOptions.eq( j ).text(),
                        rel: $childOptions.eq( j ).val()
                    }).appendTo( $moreInnerList );
                }
            }

            // Loop through the text and values and insert them into to the list
            for ( let i = 0; i < numberOfOptions; i++ ) {
                $( '<li>', {
                    text: $this.children( 'option' ).eq( i ).text(),
                    rel: $this.children( 'option' ).eq( i ).val()
                }).appendTo( $list );
            }

            // Assign list items to a variable
            const $listItems = $list.children( 'li' );
            const $innerItems = $innerList.children( 'ul' ).children( 'li' );

            // When user clicks the select element add or remove active styling
            $styledSelect.click( function( e ) {
                e.stopPropagation();
                $( '.formcontainer__form-group--select--styled' ).not( this ).each( function() {
                    $( this ).removeClass( 'active' ).next( 'ul.formcontainer__form-group--select--options' ).hide();
                });
                $( this ).toggleClass( 'active' ).next( 'ul.formcontainer__form-group--select--options' ).toggle();
            });

            // When user clicks list item, remove active styling, assign value to it accordingly and hide opened list
            $listItems.click( function( e ) {

                // If user clicks an optgroup heading, do nothing
                if ( $( this ).context.childElementCount > 0 ) {
                    e.stopPropagation();
                } else {
                    e.stopPropagation();
                    $styledSelect.text( $( this ).text() ).removeClass( 'active' );
                    $this.val( $( this ).attr( 'rel' ) );
                    $list.hide();
                }
            });

            // When user clicks inner list item, remove active styling, assign value to it accordingly and hide opened list
            $innerItems.click( function( e ) {
                e.stopPropagation();
                $styledSelect.text( $( this ).text() ).removeClass( 'active' );
                $this.val( $( this ).attr( 'rel' ) );
                $list.hide();
            });

            // When users clicks away, hide active styling
            $( document ).click( function() {
                $styledSelect.removeClass( 'active' );
                $list.hide();
            });
        });
    }

    formPreFill() {

        // Get the selected machine from session storage
        const selectedMachine = sessionStorage.getItem( 'rotator_selected_machine' );

        if ( this.machineInput.length && selectedMachine ) {

            // Pre fill and style the machine field
            this.machineInput.val( selectedMachine ).parents( '.formcontainer__form-group' ).addClass( 'focused' );
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.formInputFocus();
        this.formValidation();
        this.formDropdowns();
        this.formPreFill();
    }
}

// Export the class reference
module.exports = Form;



// WEBPACK FOOTER //
// ./assets/scripts/form.js